import { c as _c } from "react/compiler-runtime";
import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import FixedWidthContainer from 'components/consumer/FixedWidthContainer';
import useScreen from 'hooks/useScreen';
import ShopPagePromotionPanel from './components/ShopPagePromotionPanel';
import TwoColumns from './components/TwoColumns';
import { DiningRoomPanel, DecorPanel, BedroomPanel, OutdoorPanel, LivingRoomPanelMobile, LivingRoomPanelTablet, LivingRoomPanelDesktop } from './components/shopPagePanels';
const ShopPageColumns = t0 => {
  const $ = _c(30);
  const {
    config: t1
  } = t0;
  let t2;
  if ($[0] !== t1) {
    t2 = t1 === undefined ? {} : t1;
    $[0] = t1;
    $[1] = t2;
  } else {
    t2 = $[1];
  }
  const config = t2;
  const {
    isMobile,
    isMobileOrTablet
  } = useScreen();
  if (isMobile) {
    let t3;
    if ($[2] !== config) {
      t3 = <ShopPagePromotionPanel config={config} />;
      $[2] = config;
      $[3] = t3;
    } else {
      t3 = $[3];
    }
    let t4;
    let t5;
    let t6;
    let t7;
    let t8;
    if ($[4] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <LivingRoomPanelMobile />;
      t5 = <DiningRoomPanel />;
      t6 = <DecorPanel />;
      t7 = <BedroomPanel />;
      t8 = <OutdoorPanel />;
      $[4] = t4;
      $[5] = t5;
      $[6] = t6;
      $[7] = t7;
      $[8] = t8;
    } else {
      t4 = $[4];
      t5 = $[5];
      t6 = $[6];
      t7 = $[7];
      t8 = $[8];
    }
    let t9;
    if ($[9] !== t3) {
      t9 = <FixedWidthContainer noMobilePadding={true}><div className="md:[column-count:2] md:[column-gap:1.5rem] md:pb-6 lg:[column-count:3] [&_>_*]:mb-0 [&_>_*]:md:rounded-[.5rem] [&_>_*]:md:break-inside-avoid [&_>_*]:md:mb-6 [&_a]:no-underline [&_a:hover]:!text-gray">{t3}{t4}{t5}{t6}{t7}{t8}</div></FixedWidthContainer>;
      $[9] = t3;
      $[10] = t9;
    } else {
      t9 = $[10];
    }
    return t9;
  }
  if (isMobileOrTablet) {
    let t3;
    if ($[11] !== config) {
      t3 = <ShopPagePromotionPanel config={config} />;
      $[11] = config;
      $[12] = t3;
    } else {
      t3 = $[12];
    }
    let t4;
    if ($[13] === Symbol.for("react.memo_cache_sentinel")) {
      t4 = <LivingRoomPanelTablet />;
      $[13] = t4;
    } else {
      t4 = $[13];
    }
    let t5;
    if ($[14] === Symbol.for("react.memo_cache_sentinel")) {
      t5 = <div className="[&>*]:rounded-[.5rem] [&>*]:mb-6 [&>*:last-child]:mb-0 [grid-area:ShopPageTabletLeftPanel]"><DiningRoomPanel /><DecorPanel /></div>;
      $[14] = t5;
    } else {
      t5 = $[14];
    }
    let t6;
    if ($[15] === Symbol.for("react.memo_cache_sentinel")) {
      t6 = <FixedWidthContainer><div className="grid grid-rows-[auto] rounded-[.5rem] mb-0 grid-cols-[1fr_1fr] gap-6 [grid-template-areas:'ShopPagePromotionPanel_ShopPagePromotionPanel''ShopPageCategoryPanelLivingRoom_ShopPageCategoryPanelLivingRoom''ShopPageTabletLeftPanel_ShopPageTabletRightPanel']">{t4}{t5}<div className="[&>*]:rounded-[.5rem] [&>*]:mb-6 [&>*:last-child]:mb-0 [grid-area:ShopPageTabletRightPanel]"><BedroomPanel /><OutdoorPanel /></div></div></FixedWidthContainer>;
      $[15] = t6;
    } else {
      t6 = $[15];
    }
    let t7;
    if ($[16] !== t3) {
      t7 = <>{t3}{t6}</>;
      $[16] = t3;
      $[17] = t7;
    } else {
      t7 = $[17];
    }
    return t7;
  }
  let t3;
  let t4;
  if ($[18] === Symbol.for("react.memo_cache_sentinel")) {
    t3 = classNames("grid grid-rows-[auto] grid-cols-[1fr_2fr] [column-gap:2rem] [row-gap:1.5rem] mt-0 [grid-template-areas:'ShopPageDesktopLeftColumn_ShopPageDesktopMainColumn']", "[&>*]:rounded-[.5rem] [&>*]:mb-0", "[&_a]:no-underline", "[&_a]:hover:!text-gray");
    t4 = classNames("[grid-area:ShopPageDesktopLeftColumn]", "[&>*]:rounded-[.5rem] [&>*]:mt-6", "[&>*:first-child]:mt-0");
    $[18] = t3;
    $[19] = t4;
  } else {
    t3 = $[18];
    t4 = $[19];
  }
  let t5;
  if ($[20] !== config) {
    t5 = <ShopPagePromotionPanel config={config} />;
    $[20] = config;
    $[21] = t5;
  } else {
    t5 = $[21];
  }
  let t6;
  let t7;
  if ($[22] === Symbol.for("react.memo_cache_sentinel")) {
    t6 = <DiningRoomPanel />;
    t7 = <DecorPanel />;
    $[22] = t6;
    $[23] = t7;
  } else {
    t6 = $[22];
    t7 = $[23];
  }
  let t8;
  if ($[24] !== t5) {
    t8 = <div className={t4}>{t5}{t6}{t7}</div>;
    $[24] = t5;
    $[25] = t8;
  } else {
    t8 = $[25];
  }
  let t9;
  if ($[26] === Symbol.for("react.memo_cache_sentinel")) {
    t9 = <LivingRoomPanelDesktop />;
    $[26] = t9;
  } else {
    t9 = $[26];
  }
  let t10;
  if ($[27] === Symbol.for("react.memo_cache_sentinel")) {
    t10 = <div className="[grid-area:ShopPageDesktopMainColumn]">{t9}<TwoColumns column1={<div><BedroomPanel /></div>} column2={<div><OutdoorPanel /></div>} /></div>;
    $[27] = t10;
  } else {
    t10 = $[27];
  }
  let t11;
  if ($[28] !== t8) {
    t11 = <FixedWidthContainer><div className={t3}>{t8}{t10}</div></FixedWidthContainer>;
    $[28] = t8;
    $[29] = t11;
  } else {
    t11 = $[29];
  }
  return t11;
};
ShopPageColumns.propTypes = {
  config: PropTypes.object
};
export default ShopPageColumns;